import type { ResidentReportModel } from "../types/resident-report.types";
import { formatReportDate, formatReportMonth } from "../utils/report-formatters";

export function ResidentProfile({ resident, engagement }: Pick<ResidentReportModel, "resident" | "engagement">) {
  const location = [
    resident.neighborhood,
    resident.npu,
    resident.councilDistrict ? `Council District ${resident.councilDistrict}` : null,
  ]
    .filter((value): value is string => Boolean(value))
    .join(" · ");

  return (
    <section className="resident-profile">
      <div className="resident-avatar">{resident.initials}</div>
      <div className="resident-profile__content">
        <h1>{resident.name}</h1>
        <div className="resident-profile__facts">
          <span>{location || "—"}</span>
          <span>Member since {formatReportMonth(resident.memberSince)}</span>
          <span>Last active {formatReportDate(resident.lastActive)}</span>
        </div>
        {resident.tags.length > 0 && (
          <div className="resident-tags">
            {resident.tags.map((tag) => (
              <span key={tag}>{tag}</span>
            ))}
          </div>
        )}
      </div>
      {engagement ? (
        <div className="resident-profile__signals" aria-label="Resident engagement signals">
          <article className="resident-profile__score">
            <span>Engagement score</span>
            <strong>{engagement.score}<small>/100</small></strong>
            <p>{engagement.scoreDetail}</p>
          </article>
          <article className="resident-profile__risk">
            <span>Drop-off risk</span>
            <strong>{engagement.dropOffRisk}</strong>
            <p>{engagement.dropOffRiskDetail}</p>
          </article>
        </div>
      ) : null}
    </section>
  );
}
